const env = process.env.CODE_ENV || process.env.NODE_ENV || "production";
/** 可灵创作页面 */
export const KLING_HOME_CREATE = {
  staging: `https://aiportal.staging.kuaishou.com/text-to-video/new`,
  preonline: `https://aiportal.prt.kuaishou.com/text-to-video/new`,
  production: `https://klingai.kuaishou.com/text-to-video/new`,
}[env];
